import React from 'react';
import './About.css';

function About() {
  return (
    <div className="container">
      <h1 className="page-title">Обо мне</h1>
      
      <section className="about-section">
        <h2>Значение имени</h2>
        <div className="card name-meaning">
          <p>
            <strong>София</strong> — это имя греческого происхождения, означающее <em>"мудрость"</em>. 
            Оно происходит от древнегреческого слова "σοφία" (sophia).
          </p>
          <p>
            В различных культурах имя София ассоциируется с мудростью, знанием и божественной мудростью.
            В православии Святая София олицетворяет божественную мудрость.
          </p>
        </div>
      </section>
      
      <section className="about-section">
        <h2>Популярность имени</h2>
        <div className="card">
          <p>
            София — одно из самых популярных женских имён в мире. В различных странах оно входит в 
            топ-10 самых популярных имён для девочек:
          </p>
          <ul className="popularity-list">
            <li>Россия — входит в топ-3 самых популярных имён</li>
            <li>США — входит в топ-5 популярных имён</li>
            <li>Италия — одно из самых популярных имён</li>
            <li>Испания — входит в топ-10 популярных имён</li>
            <li>Польша — входит в топ-5 популярных имён</li>
          </ul>
        </div>
      </section>
      
      <section className="about-section">
        <h2>Знаменитые тезки</h2>
        <div className="card">
          <div className="famous-names">
            <div className="famous-name">
              <h3>София Ротару</h3>
              <p>Известная советская и украинская певица</p>
            </div>
            <div className="famous-name">
              <h3>София Лорен</h3>
              <p>Итальянская актриса, обладательница премии "Оскар"</p>
            </div>
            <div className="famous-name">
              <h3>София Коппола</h3>
              <p>Американский кинорежиссёр, сценарист и продюсер</p>
            </div>
            <div className="famous-name">
              <h3>София Вергара</h3>
              <p>Колумбийская и американская актриса, модель</p>
            </div>
          </div>
        </div>
      </section>
      
      <section className="about-section">
        <h2>Интересные факты о январских детях</h2>
        <div className="card">
          <ul className="facts-list">
            <li>
              Дети, родившиеся в январе, как правило, более самостоятельны и независимы
            </li>
            <li>
              Январские дети часто проявляют лидерские качества с раннего возраста
            </li>
            <li>
              Исследования показывают, что январские дети часто обладают хорошими аналитическими способностями
            </li>
            <li>
              Дети, рождённые в январе, обычно очень целеустремлённые и ответственные
            </li>
            <li>
              В школе январские дети часто демонстрируют хорошую дисциплину и усидчивость
            </li>
          </ul>
        </div>
      </section>
      
      <section className="about-section">
        <h2>Факты о Козерогах</h2>
        <div className="card">
          <div className="zodiac-facts">
            <div className="zodiac-info">
              <h3>Характеристики Козерога:</h3>
              <ul>
                <li>Целеустремлённость</li>
                <li>Ответственность</li>
                <li>Практичность</li>
                <li>Надёжность</li>
                <li>Дисциплинированность</li>
                <li>Терпение</li>
              </ul>
            </div>
            <div className="zodiac-info">
              <h3>Таланты Козерогов:</h3>
              <ul>
                <li>Организаторские способности</li>
                <li>Умение планировать</li>
                <li>Стратегическое мышление</li>
                <li>Внимание к деталям</li>
                <li>Настойчивость в достижении целей</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About; 